export default __webpack_public_path__ + "static/media/tete34.c1143ca1.png";